<div class="backdrop" (click)="onClose()"></div>
<div class="cerca-glossari-box">
    <div class="modalHeader">
        Glossari
        <mat-icon class="chiudiModale" (click)="onClose()">highlight_off</mat-icon>
    </div>
    <div style="display: flex;">
        <form [formGroup]="formCercaGlossari" class="form-horizontal" (ngSubmit)="onSubmitFiltersModal()">
            <div class="form-group row">
                <div class="col">
                    <label for="name">Nome</label>
                    <input type="text" name="name" id="name" class="form-control" formControlName="name"
                        autocomplete="off">
                </div>
                <div class="col">
                    <label for="transliteration">Traslitterazione</label>
                    <input type="text" name="transliteration" id="transliteration" class="form-control"
                        formControlName="transliteration" autocomplete="off">
                </div>
                <div class="col">
                    <label for="translation">Traduzione</label>
                    <input type="text" name="translation" id="translation" class="form-control"
                        formControlName="translation" autocomplete="off">
                </div>
                <div class="col">
                    <label for="original">Ebraico</label>
                    <input type="text" name="original" id="original" class="form-control" formControlName="original"
                        dir="rtl" autocomplete="off">
                </div>
                <div class="col">
                    <label for="type">Tipo</label>
                    <mat-select name="type" id="type" class="form-control" formControlName="type">
                        <mat-option value="any">Qualsiasi tipo</mat-option>
                        <mat-option *ngFor="let tipo of elencoTipiGlossario" value="{{tipo.name}}">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <div class=" row">
                <div class="col" style="margin: auto; float:left">
                    <label for="locked">
                        <mat-checkbox disableRipple=true type="checkbox" name="locked" id="locked"
                            formControlName="locked">
                            Bloccato
                        </mat-checkbox>
                    </label>
                </div>
                <div style="float: right;">
                    <button class="btn btn-primary" type="submit">Filtra</button>
                    <button class="btn btn-primary" type="button" [disabled]="!modalSelection"
                        (click)="onAssociaSelezioneHandler()">Associa</button>
                </div>
            </div>
        </form>
    </div>
    <div style="height: 50vh; -webkit-height: 50vh; -moz-height:50vh;overflow-y:scroll;">
        <div *ngIf="isLoadingModal" class="spinner-containerModale">
            <div class="spinner-center">
                <app-mat-spinner-overlay></app-mat-spinner-overlay>
            </div>
        </div>
        <div>
            <mat-paginator [pageSizeOptions]="[25, 50, 75, 100]" [length]="resultsLength" showFirstLastButtons
                class="paginatorModal"></mat-paginator>
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef>
                        <label>Tipo</label>
                    </th>
                    <td mat-cell *matCellDef="let row" (click)="onSelectModalGlossary(row)"
                        [style.backgroundColor]="modalSelection && row.id === modalSelection.id ? '#0097877d' : ''">
                        <mat-icon matTooltip="{{row.type}}" [ngStyle]="row.type| glossaryColor">fiber_manual_record
                        </mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>
                        <label>Voce</label>
                    </th>
                    <td mat-cell *matCellDef="let row; let index = index" (click)="onSelectModalGlossary(row)"
                        [style.backgroundColor]="modalSelection && row.id === modalSelection.id ? '#0097877d' : ''">
                        <div>
                            {{row.name === '' ? '[...]' : row.name}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="transliteration">
                    <th mat-header-cell *matHeaderCellDef>
                        <label>Traslitterato</label>
                    </th>
                    <td mat-cell *matCellDef="let row; let index = index" (click)="onSelectModalGlossary(row)"
                        [style.backgroundColor]="modalSelection && row.id === modalSelection.id ? '#0097877d' : ''">
                        {{row.transliteration === '' ? '[...]' : row.transliteration}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="translation">
                    <th mat-header-cell *matHeaderCellDef>
                        <label>Traduzione</label>
                    </th>
                    <td mat-cell *matCellDef="let row; let index = index" (click)="onSelectModalGlossary(row)"
                        [style.backgroundColor]="modalSelection && row.id === modalSelection.id ? '#0097877d' : ''">
                        {{row.translation === '' ? '[...]' : row.translation}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="original">
                    <th mat-header-cell *matHeaderCellDef>
                        <label>Ebraico</label>
                    </th>
                    <td mat-cell *matCellDef="let row; let index = index" (click)="onSelectModalGlossary(row)"
                        [style.backgroundColor]="modalSelection && row.id === modalSelection.id ? '#0097877d' : ''">
                        <p style="text-align: right;" dir="rtl">{{row.original === '' ? '[...]' : row.original}}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="username">
                    <th mat-header-cell *matHeaderCellDef>
                        <label>Autore</label>
                    </th>
                    <td mat-cell *matCellDef="let row" (click)="onSelectModalGlossary(row)"
                        [style.backgroundColor]="modalSelection && row.id === modalSelection.id ? '#0097877d' : ''">
                        <em class="author">
                            <mat-icon matTooltip="{{'ruoli.' + row.accountType | translate}}"
                                style="font-size: 11px;vertical-align: sub;" [ngStyle]="row.accountType | roleColor">
                                fiber_manual_record</mat-icon>{{row.username}}
                        </em>
                    </td>
                </ng-container>

                <ng-container matColumnDef="locked">
                    <th mat-header-cell *matHeaderCellDef>
                        <label>Tipo</label>
                    </th>
                    <td mat-cell *matCellDef="let row" (click)="onSelectModalGlossary(row)"
                        [style.backgroundColor]="modalSelection && row.id === modalSelection.id ? '#0097877d' : ''">
                        <mat-icon class="lock">{{row.locked ? 'lock' : 'lock_open'}}</mat-icon>
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="colonneVisibili; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: colonneVisibili"></tr>
            </table>
            <div *ngIf="dataSource ? dataSource.length === 0 : true">
                Nessuna voce di glossario risponde ai criteri
            </div>
        </div>
    </div>
</div>